import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import Archive2022 from 'views/MathClub/components/Archive2022';
import Sidebar2026 from '../MathClub2023/components/Sidebar2026/Sidebar2026';


const Mathclasses9to122026 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });

    const [config, setConfig] = useState({ base_image_url_2026: '' });
    useEffect(() => {
        fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
            .then(response => response.json())
            .then(data => setConfig(data))
            .catch(error => console.error('Error fetching config:', error));
    }, []);

    const p1 = `${config.base_image_url_2026}/home/events-activities/association/MathClub/MathCCA9to12/1.webp`;
    const p2 = `${config.base_image_url_2026}/home/events-activities/association/MathClub/MathCCA9to12/2.webp`;
    const p3 = `${config.base_image_url_2026}/home/events-activities/association/MathClub/MathCCA9to12/3.webp`;
    const p4 = `${config.base_image_url_2026}/home/events-activities/association/MathClub/MathCCA9to12/4.webp`;
    const p5 = `${config.base_image_url_2026}/home/events-activities/association/MathClub/MathCCA9to12/5.webp`;
    const p6 = `${config.base_image_url_2026}/home/events-activities/association/MathClub/MathCCA9to12/6.webp`;

    const photos = [
        {
            src: p1,
            source: p1,
            rows: 1,
            cols: 1,
        },
        {
            src: p3,
            source: p3,
            rows: 1,
            cols: 1,
        },
        {
            src: p2,
            source: p2,
            rows: 1,
            cols: 1,
        },
        {
            src: p4,
            source: p4,
            rows: 1,
            cols: 1,
        },
        {
            src: p5,
            source: p5,
            rows: 1,
            cols: 1,
        },
         {
            src: p6,
            source: p6,
            rows: 1,
            cols: 1,
        },
        

    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h4' align='center'>
                                    TOPIC: THE HIDDEN AND ULTIMATE INVENTION                                  
                                </Typography>
                                <br></br>
                               
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                                    CLASSES 9-12   Date: 18/08/2026
                                </Typography>

                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
The Mathematics Association organized an innovative activity titled<strong> “Hidden and Ultimate Invention”</strong> with the objective of creating awareness among students about the importance of Mathematics in inventions and technological developments. The event provided students with an opportunity to explore the connection between Mathematical concepts, creativity, innovation and real-life applications.
<br></br>
Students presented their ideas through power point presentation and explained how mathematical concepts such as numbers, geometry, measurement, patterns, logic and calculations are used in everyday inventions. 
The participants also shared their views on important inventions and discussed how mathematics has contributed to scientific and technological progress. The activity created an interactive and enthusiastic learning environment.        
                            <br></br>
Students participated actively and enthusiastically throughout the programme. They demonstrated creativity, confidence, teamwork and problem-solving abilities while presenting their ideas.
 The activity also provided an opportunity for students to improve their public-speaking and presentation skills.
  <br></br>
      The “Hidden and Ultimate Invention” activity organized by the Mathematics Association was successfully conducted and received enthusiastic participation from the students. The programme effectively highlighted the significant role of mathematics in inventions and everyday life. It was an informative,
interactive and enjoyable learning experience for all the participants. The activity encouraged students to think beyond textbook and understand its practical importance.   
                                </Typography>
                            </Box>
                            <Typography
                                      variant={'h6'}
                                      color={'primary'}
                                      align={'center'}
                                      fontWeight={'normal'}
                                    ><br/>
"EVERY HUMAN INVENTION IS A MATHEMATICAL FORMULA BROUGHT TO LIFE."                            
                            <br/>
                                    </Typography>
                            
                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 200 : 100}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Box marginBottom={4}>
                            <Sidebar2026/>
                        </Box>
                        <Box marginBottom={4}>
                            <Archive2022/>
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default Mathclasses9to122026;